import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/editPublic/uptime.editPublic.upsert.mutation.gql"
import { UPTIME_CONFIG_REFETCH_QUERIES } from "@/v2-backoffice-client/uptime/config/uptime.config.query"
import type {
  UptimeEditPublicUpsertMutation,
  UptimeEditPublicUpsertMutationVariables,
} from "@/v2-backoffice-client/uptime/editPublic/__types__/uptime.editPublic.upsert.mutation"

type Options = MutationHookOptions<
  UptimeEditPublicUpsertMutation,
  UptimeEditPublicUpsertMutationVariables
>

// useUptimeEditPublicUpsertMutation writes a row into
// status.TargetOverrides for one (Source, Identifier). After it
// returns we refetch the long-cached UptimeConfigQuery so any
// preview UI (e.g. the read-only public preview underneath the
// form) re-renders against the new override without us having to
// hand-merge the response into Apollo's cache.
export function useUptimeEditPublicUpsertMutation(options?: Options) {
  return useMutation<
    UptimeEditPublicUpsertMutation,
    UptimeEditPublicUpsertMutationVariables
  >(mutation, {
    refetchQueries: [...UPTIME_CONFIG_REFETCH_QUERIES],
    awaitRefetchQueries: true,
    ...options,
  })
}
